// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1gI4S","boxTitle":"Qualiphy_boxTitle__1Neif","box":"Qualiphy_box__gNRiQ","toggleWrap":"Qualiphy_toggleWrap__2xwHH"};